module.exports = __webpack_public_path__ + "img/cod-logo-2.6f43fc8d.svg";